/* eslint-disable react/prop-types */
import classes from './index.module.css';
/**
 * item reason block
 * @param {*} title  reason
 * @param {*} isShow  是否展示reason的title，有理赔的不展示
 * @param {*} btnText  右侧按钮文案
 * @param {*} additional  comments
 * @param {*} files  ra附件图片
 * @returns children
 */
export const RemarkPanel = ({
  title, btnText, onClick, additional, isShow = true, files = [],
}) => (
  <section className={classes.remark}>
    <section className={classes.remark_header}>
      <section>
        {isShow && <span className={classes.bold}>Return reason: </span>}
        {title}
      </section>

      {btnText && <section className={classes.remark_link} onClick={onClick}>{btnText}</section>}
    </section>
    {!!files.length && (
      <section className={classes.photos}>
        <span className={classes.bold}>Photos:&nbsp;</span>
        <span>{files.join('; ')}</span>
      </section>
    )}
    {!!additional && (
      <section className={classes.additional}>
        <span className={classes.bold}>Additional comments: </span>
        {additional}
      </section>
    )}
  </section>
);
